export default {"src":"/_next/static/image/src/images/CheckoutConfirmation/dog-paw.d7104af426312d7d339d7ecaed8076dd.svg","height":70,"width":69};